import React from 'react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';

import { useEmailField } from '../../hooks/useEmailField';

interface BusinessEmailAddressInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
  label?: string;
  required?: boolean;
  submitting?: boolean;
}

export default function BusinessEmailAddressInput({
  value,
  onChange,
  disabled,
  label,
  required = false,
  submitting,
}: BusinessEmailAddressInputProps) {
  const { t } = useTranslation();
  // Normalizes to lower case while typing and validates the address.
  const { fieldProps } = useEmailField({
    value,
    onChange,
    required,
    submitting,
    disabled,
  });

  return (
    <TextField
      label={
        label ? label : `${t('formInputs.businessEmailAddressInputLabel') + (required ? ' *' : '')}`
      }
      variant='outlined'
      fullWidth
      disabled={disabled}
      {...fieldProps}
    />
  );
}
